'use client';

import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'next/navigation';
import { useMemo, useEffect } from 'react';
import * as Sentry from 'utils/errorTracking';
import { getPageData } from 'utils/lib/strapi';
import { getServerError } from 'utils/helpers';

const useStrapiBanner = ({ queryKey, flag, enabled = true }) => {
  const searchParams = useSearchParams();
  const strapiContentId = searchParams?.get('strapiContentId');

  const { data, isFetching, isPending, isError, error } = useQuery({
    queryKey: [queryKey, strapiContentId],
    queryFn: () =>
      getPageData({
        type: flag,
        preview: Boolean(strapiContentId),
        id: strapiContentId,
      }),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled,
  });

  useEffect(() => {
    if (isError && error && typeof Sentry !== 'undefined' && Sentry.captureException) {
      Sentry.captureException(getServerError(error));
    }
  }, [isError, error]);

  const isLoading = isPending && isFetching;
  const isValid = useMemo(
    () => !isLoading && !isError && !!data && data?.length !== 0,
    [isLoading, isError, data],
  );

  return {
    isLoading,
    isFetching,
    isValid,
    data,
  };
};

export default useStrapiBanner;
